// import Button from "components/superapp/button";
// import { ButtonSize, ButtonType } from "components/superapp/button/constants";
import React from "react";
import { useTranslation } from "react-i18next";
// import { StyleSheet, Text, useWindowDimensions, View } from "react-native";
// import RenderHTML from 'react-native-render-html';

// import { getHeight, getWidth } from "utils/helpers/relativeSizes";

// import translations from "utils/helpers/localization";
// import {
//   LocationApprovedIcon,
//   LocationCheckIcon,
//   LocationErrorIcon,
// } from "assets/svgs";
import locationIcon from '../../assets/locationIcon.svg'
import locationErrorIcon from '../../assets/locationError.svg'
import locationSuccess from  '../../assets/locationSuccess.svg'
// import BottomSheetComponent from "components/superapp/bottomsheet";
// import { COLOR_WHITE } from "assets/Colors";
import useGeoLocation from "./useGeoLocation";
import { LOCATION_PERMISSION_STATUS } from "./helper";
import BottomSheetModal from "../BottomSheetModal";
import { getHeight, getWidth } from "../../utils/relativeSizes";

const LocationCheck = () => {
  const { t } = useTranslation();
  const {
    handleCloseBottomSheet,
    openSettings,
    denyPermission,
    allowPermission,
    locationModal,
    locationPermissionStatus,
    userFromBannedState,
    subHeading,
    allowGps,
    locationErrorObject,
  } = useGeoLocation();

  const getModalIcon = () => {
    switch (locationPermissionStatus) {
      case LOCATION_PERMISSION_STATUS.GRANTED:
        return locationSuccess;
      case LOCATION_PERMISSION_STATUS.DENIED:
      case LOCATION_PERMISSION_STATUS.BLOCKED:
      case LOCATION_PERMISSION_STATUS.UNAVAILABLE:
      case LOCATION_PERMISSION_STATUS.RESTRICTED:
        return locationErrorIcon;
      case LOCATION_PERMISSION_STATUS.PROMPT:
      case LOCATION_PERMISSION_STATUS.NOT_ASKED:
      default:
        return locationIcon;
    }
  };

  const getModalTitle = () => {
    switch (locationPermissionStatus) {
      case LOCATION_PERMISSION_STATUS.GRANTED:
        return t('locationSuccessT1');
      case LOCATION_PERMISSION_STATUS.DENIED:
        return t('locationDeniedT1');
      case LOCATION_PERMISSION_STATUS.BLOCKED:
        return t('locationBlockedT1');
      case LOCATION_PERMISSION_STATUS.UNAVAILABLE:
        return t('locationUnavailableT1');
      case LOCATION_PERMISSION_STATUS.PROMPT:
      case LOCATION_PERMISSION_STATUS.NOT_ASKED:
        return t('locationCheckT1');
      case LOCATION_PERMISSION_STATUS.RESTRICTED:
        return t('oops');
      default:
        return t('locationCheckT1');
    }
  };

  const getModalActions = () => {
    if (locationPermissionStatus === LOCATION_PERMISSION_STATUS.GRANTED || locationPermissionStatus === LOCATION_PERMISSION_STATUS.RESTRICTED || locationPermissionStatus === LOCATION_PERMISSION_STATUS.DENIED) {
      return [{
        label: t('okay'),
        onClick: handleCloseBottomSheet,
        btnClass: "primaryBtn",
      }];
    }
    
    if (locationPermissionStatus === LOCATION_PERMISSION_STATUS.NOT_ASKED) {
      return allowGps ? [
        {
          label: t('allow'),
          onClick: () => allowPermission(locationErrorObject),
          btnClass: "primaryBtn",
        },
        {
          label: t('deny'),
          onClick: denyPermission,
          btnClass: "secondaryBtn"
        }
      ] : [{
        label: t('okay'),
        onClick: handleCloseBottomSheet,
        btnClass: "primaryBtn",
      }];
    }

    // return [{
    //   label: t('okay'),
    //   onClick: handleCloseBottomSheet,
    //   btnClass: "primaryBtn",
    // }];

    // return [{
    //   label: t('openSettings'),
    //   onClick: openSettings,
    //   btnClass: "primaryBtn",
    // }];
  };

  return (
    <BottomSheetModal
      isOpen={locationModal}
      modalIcon={getModalIcon()}
      title={getModalTitle()}
      content={
        <div 
          style={{ textAlign: "center" }}
          dangerouslySetInnerHTML={{ __html: subHeading }}
        />
      }
      actions={getModalActions()}
      onClose={handleCloseBottomSheet}
    />
  );
};

export default LocationCheck;
